// Signed-in area: requires a session, runs the sync engine for all dictionaries.
import { useEffect, useMemo, useRef } from 'react';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { loadUser, useDictionaries } from '@/state/session';
import { startSyncEngine } from '@/sync/engine';

export const Route = createFileRoute('/_app')({
  beforeLoad: async () => {
    const user = await loadUser();
    if (!user) throw redirect({ to: '/auth', replace: true });
    return { user };
  },
  component: AppLayout,
});

function AppLayout() {
  const dictionaries = useDictionaries();
  const ids = useMemo(() => dictionaries.map((d) => d.id), [dictionaries]);
  const idsRef = useRef<string[]>([]);
  useEffect(() => {
    idsRef.current = ids;
  }, [ids]);
  useEffect(() => {
    const handle = startSyncEngine(() => idsRef.current);
    return () => handle.stop();
  }, []);
  // A newly appeared dictionary (created, accepted share) is pulled right away
  const key = ids.join(',');
  useEffect(() => {
    if (!navigator.onLine) return;
    void import('@/sync/pull').then(({ puller }) => ids.forEach((id) => void puller.pull(id)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return <Outlet />;
}
